import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Heading,
  HStack,
  Icon,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Stack,
} from "@chakra-ui/react";
import axios from "axios";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FaArrowLeft, FaFilter, FaUndo } from "react-icons/fa";
import { connect } from "react-redux";
import { moveToFolder } from "../_actions/folderActions";
import { resetCardsSelection } from "../_actions/folderActions";
import {
  deleteItemsInBulk,
  fetchData,
  resetPage,
  search,
} from "../_actions/sidebarSliderActions";
import { BACK_FROM_STUDIO } from "../_actions/types";
import PageTitleDD from "../_components/common/PageTitleDD";
import {
  ImageItemWithoutDrag,
  NavbarIconButton,
  ShowCenterSpinner,
  ShowNoContent,
} from "../_components/common/statelessView";
import TLDRInfiniteScroll from "../_components/common/TLDRInfiniteScroll";
import TLDRTitleSearch from "../_components/common/TLDRTitleSearch";
import {
  SAVED_ELEMENTS_PANEL,
  SAVED_TEMPLATES_PANEL,
} from "../_components/details/constants";
import RecentFoldersRow from "../_components/home/RecentFoldersRow";
import AssetsCardView from "../_components/styled/home/AssetsCardView";
import { EmptyStateScreen } from "../_components/styled/home/statelessView";
import {
  HomeComponent,
  StyledMarketplaceContent,
  StyledMarketPlaceGallery,
} from "../_components/styled/home/stylesHome";
import TldrSelectedCardsRow from "../_components/styled/home/TldrSelectedCardRow";
import TldrTitleRow from "../_components/styled/home/TldrTitleRow";
import TldrTitleSearchRow from "../_components/styled/home/TldrTitleSearchRow";
import { analyticsTrackEvent } from "../_utils/common";
import {
  ContentTypes,
  MAIN_CONTAINER_SCROLLABLE_TARGET_ID,
} from "../_utils/constants";
import {
  LAYOUTS,
  MY_COMPONENTS,
  MY_TEMPLATES,
  SHARED_WITH_ME_TEMPLATES,
  TEAM_TEMPLATES,
  TEMPLATES_SCREEN,
} from "../_utils/routes";
import Drawer from "../_components/drawer/Drawer";
import TldrMobileSearchSuggestion from "../_components/common/TldrMobileSearchSuggestion";

const teamTemplatesDDItems = [
  {
    id: "all",
    label: "All templates",
    path: TEAM_TEMPLATES,
  },
  {
    id: "draft",
    label: "My templates",
    path: MY_TEMPLATES,
  },
  {
    id: "published",
    label: "Shared with me",
    path: SHARED_WITH_ME_TEMPLATES,
  },
];

const FilterStatuses = {
  ALL: "",
  DRAFT: 0,
  PUBLISHED: 1,
};

const defaultFiltersState = {
  [FilterStatuses.ALL]: true,
  [FilterStatuses.DRAFT]: true,
  [FilterStatuses.PUBLISHED]: true,
};

class MyTemplatesScreen extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      inProgress: false,
      filterOptions: defaultFiltersState,
      isDrawerOpen: false,
      showMobileSearchSuggestions: false,
    };
  }

  componentDidMount() {
    this.onStatusChange().then(() => {
      this.loadPage(1);
    });
  }

  onStatusChange = () => {
    return new Promise((resolve) => {
      resolve(this.props.resetPage(""));
    });
  };

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  loadPage = (groupKey, status = "") => {
    this.props.fetchData(this.props.sidebarSlider.iconsSource, {
      ...this.props,
      viewAll: true,
      groupKey: groupKey,
      org: this.props.selectedOrg,
      status: status,
    });
  };

  preparePayload = (data) => {
    const message = {
      mime: "shape",
      type: "component",
      payload: {
        name: data.content_name || data.title || "New Template",
        type: data.template,
        height: data.image_height,
        width: data.image_width,
        publish: data?.publish ? "published" : "draft",
      },
      content: {
        meta: {
          ...data,
        },
      },
    };
    return message;
  };

  handleSearch = (keyword) => {
    this.setState({ searchTerm: keyword });
  };

  handleSearchClear = (searchPhrase) => {
    this.setState({ searchTerm: searchPhrase }, () => this.handleSearchSavedElements());
  };

  handleSearchSavedElements = () => {
    this.setState({ showMobileSearchSuggestions: false });
    this.props.resetAssets();

    if (this.state.searchTerm.trim().length > 0) {
      this.props.search(this.props.sidebarSlider.iconsSource, this.state.searchTerm, {
        ...this.props,
        viewAll: true,
        page: 1,
        org: this.props.selectedOrg,
      });
    } else {
      this.loadPage(1);
    }
  };

  moveToFolder = (folderId, folderName) => {
    const { selectedCards } = this.props;
    let templateIds = [];

    selectedCards.forEach((item) => {
      templateIds.push(item.content_id);
    });

    const payload = {
      content_ids: templateIds,
    };
    this.props.resetPage("");

    return new Promise((resolve, reject) => {
      this.props
        .moveToFolder(payload, folderId, folderName, this.signal.token)
        .then((res) => {
          this.loadPage(1);
          this.props.resetCardsSelection();
          resolve();
        });
    });
  };

  deleteSelected = () => {
    const { selectedCards } = this.props;
    let templateIds = [];

    selectedCards.forEach((item) => {
      templateIds.push(item.content_id);
    });

    if (templateIds.length > 0) {
      return new Promise((resolve, reject) => {
        this.props
          .deleteItemsInBulk(
            {
              ...this.props,
              type: ContentTypes.TEAM_TEMPLATE,
              ids: templateIds,
            },
            this.signal.token
          )
          .then(() => {
            resolve();
          });
      });
    }
  };

  handleFiltersChange = (event) => {
    const { filterOptions } = this.state;
    const value = event.target.value;
    const checked = event.target.checked;
    let updatedFilters = {};
    const teamTemplateFilters = new Set();

    analyticsTrackEvent("teamTemplateFilterChange", {
      type: value,
      checked,
    });

    // all options selected
    if (value === FilterStatuses.ALL && checked) {
      this.handleFilterReset();
      return;
    }

    // none of the options selected
    if (value === FilterStatuses.ALL && !checked) {
      updatedFilters = {
        [FilterStatuses.ALL]: false,
        [FilterStatuses.DRAFT]: false,
        [FilterStatuses.PUBLISHED]: false,
      };

      this.setState({ filterOptions: updatedFilters });
      return;
    }

    // one of the option selected
    updatedFilters = {
      ...filterOptions,
      [value]: checked,
      [FilterStatuses.ALL]:
        checked &&
        Object.values(filterOptions).filter((item) => item).length ===
        Object.keys(filterOptions).length - 2,
    };

    this.setState({
      filterOptions: updatedFilters,
    });

    Object.keys(updatedFilters).forEach((key) => {
      if (updatedFilters[key] && Number(key) === FilterStatuses.DRAFT) {
        teamTemplateFilters.add(FilterStatuses.DRAFT);
        return;
      }

      if (updatedFilters[key] && Number(key) === FilterStatuses.PUBLISHED) {
        teamTemplateFilters.add(FilterStatuses.PUBLISHED);
        return;
      }
    });

    this.onFilterChange([...teamTemplateFilters]);
  };

  handleFilterReset = () => {
    this.setState({ filterOptions: defaultFiltersState });
    this.onStatusChange().then(() => {
      this.loadPage(1);
    });
  };

  handleSearchFocusOnMobile = () => {
    this.setState({ showMobileSearchSuggestions: true });
  };

  handleSearchBlurOnMobile = () => {
    this.setState({ showMobileSearchSuggestions: false });
  };

  onFilterChange = (filters) => {
    if (filters.length === 1 && filters.includes(FilterStatuses.DRAFT)) {
      this.onStatusChange().then(() => {
        this.loadPage(1, FilterStatuses.DRAFT);
      });
      return;
    }

    if (filters.length === 1 && filters.includes(FilterStatuses.PUBLISHED)) {
      this.onStatusChange().then(() => {
        this.loadPage(1, FilterStatuses.PUBLISHED);
      });
      return;
    }

    if (filters.length > 1) {
      this.onStatusChange().then(() => {
        this.loadPage(1);
      });
      return;
    }
  };

  render() {
    const { filterOptions, isDrawerOpen, showMobileSearchSuggestions, searchTerm } = this.state;
    const { sidebarSlider, t, selectedCards } = this.props;
    const { loaded, payload, hasMore } = sidebarSlider;

    const childElements = payload.map((asset, index) => {
      const payload = this.preparePayload(asset);
      const assetId = asset.content_id || asset.id;

      return (
        <AssetsCardView
          key={assetId}
          payload={payload}
          hasAction={true}
          type={"svg"}
          modalFor={"template"}
          templateActionMenu={this.props.panelType === SAVED_TEMPLATES_PANEL}
          contentType={ContentTypes.TEAM_TEMPLATE}
          showExtraOptions
          onActionComplete={() =>
            setTimeout(() => {
              this.loadPage(1);
            }, 3000)
          }
        >
          <ImageItemWithoutDrag
            data={payload}
            key={`${assetId}_${Date.now()}`}
            url={asset.image}
            alt={"asset"}
            width={200}
            height={200}
            source={"Simplified"}
            hasAction={false}
            type={"svg"}
            modalFor={"template"}
            showOverlayInfo={false}
          />
        </AssetsCardView>
      );
    });

    return (
      <>
        <HomeComponent isMobileView={this.props.isMobileView}>
          <StyledMarketplaceContent>
            {selectedCards.length > 0 && !this.props.isMobileView ? (
              <TldrSelectedCardsRow
                type="svg"
                displayType={
                  this.props.panelType === SAVED_TEMPLATES_PANEL
                    ? "Templates"
                    : "Component"
                }
                displayNamePluralForm="stories"
                marginBottom="0.3rem"
                marginTop="-1.5rem"
                onMoveToFolder={this.moveToFolder}
                onDeleteSelected={this.deleteSelected}
              />
            ) : !this.props.isMobileView ? (
              <Flex
                direction="row"
                align="center"
                justify="space-between"
                py="0"
                px="2.5rem"
                minH="36px"
                mb="0"
              >
                <Box display={["none", "none", "none", "flex"]}>
                  <TldrTitleRow
                    title={
                      this.props.panelType === SAVED_TEMPLATES_PANEL
                        ? "Templates"
                        : "Component"
                    }
                    subTitle={
                      this.props.panelType === SAVED_TEMPLATES_PANEL
                        ? t("intro_page.explore_Saved")
                        : t("intro_page.saved_components")
                    }
                    titleComponent={
                      this.props.panelType === SAVED_TEMPLATES_PANEL ? (
                        <PageTitleDD ddItems={teamTemplatesDDItems} />
                      ) : null
                    }
                  />
                </Box>

                <TldrTitleSearchRow
                  handleSearch={this.handleSearch}
                    handleEnterKeyEvent={this.handleSearchSavedElements}
                    onClear={this.handleSearchClear}
                  searchPlaceholder={
                    this.props.panelType === SAVED_TEMPLATES_PANEL
                      ? t("intro_page.search_Saved_temp")
                      : t("intro_page.search_saved_comp")
                  }
                  showNewFolderButton
                  showFilterOptions
                >
                  <Popover isLazy placement="bottom">
                    <PopoverTrigger>
                      <NavbarIconButton
                        icon={<Icon as={FaFilter} />}
                        ml="0.75rem"
                        tooltip={t("filters.heading")}
                        color={
                          filterOptions[FilterStatuses.ALL]
                            ? "unset"
                            : "brand.primary"
                        }
                      />
                    </PopoverTrigger>
                    <PopoverContent>
                      <PopoverHeader>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Heading as="h5" size="md" mb="0">
                            {t("filters.heading")}
                          </Heading>
                          <Button
                            size="sm"
                            leftIcon={<Icon as={FaUndo} />}
                            onClick={this.handleFilterReset}
                          >
                            {t("filters.reset_filters")}
                          </Button>
                        </Flex>
                      </PopoverHeader>
                      <PopoverArrow />
                      <PopoverBody pb="4">
                        <Heading as="h6" size="sm">
                          {t("filters.status.heading")}
                        </Heading>
                        <Checkbox
                          mb="1"
                          size="sm"
                          onChange={this.handleFiltersChange}
                          isChecked={filterOptions[FilterStatuses.ALL]}
                          value={FilterStatuses.ALL}
                        >
                          {t("filters.status.all")}
                        </Checkbox>
                        <Stack pl="2" spacing="1">
                          <Checkbox
                            onChange={this.handleFiltersChange}
                            isChecked={filterOptions[FilterStatuses.DRAFT]}
                            value={FilterStatuses.DRAFT}
                            mb="0"
                            size="sm"
                          >
                            {t("filters.status.draft")}
                          </Checkbox>
                          <Checkbox
                            isChecked={filterOptions[FilterStatuses.PUBLISHED]}
                            onChange={this.handleFiltersChange}
                            value={FilterStatuses.PUBLISHED}
                            size="sm"
                          >
                            {t("filters.status.published")}
                          </Checkbox>
                        </Stack>
                      </PopoverBody>
                    </PopoverContent>
                  </Popover>
                </TldrTitleSearchRow>
              </Flex>
            ) : null}

            {/* for mobile view */}
            {this.props.isMobileView ? (
              <HStack>
                <TLDRTitleSearch
                  searchConfig={{
                    onClear: this.handleSearchClear,
                    onFocus: this.handleSearchFocusOnMobile,
                  }}
                  searchText={searchTerm}
                  placeholder={
                    this.props.panelType === SAVED_TEMPLATES_PANEL
                      ? t("intro_page.search_Saved_temp")
                      : t("intro_page.search_saved_comp")
                  }
                />

                {showMobileSearchSuggestions ? (
                  <TldrMobileSearchSuggestion
                    searchConfig={{
                      handleSearch: this.handleSearch,
                      onBlur: this.handleSearchBlurOnMobile,
                      onClear: this.handleSearchClear,
                      handleEnterKeyEvent: this.handleSearchSavedElements,
                    }}
                    searchTerm={searchTerm}
                    isOpen={showMobileSearchSuggestions}
                    searchInFormats={false}
                    placeholder={
                      this.props.panelType === SAVED_TEMPLATES_PANEL
                        ? t("intro_page.search_Saved_temp")
                        : t("intro_page.search_saved_comp")
                    }
                  />
                ) : null}

                <IconButton
                  icon={<FaFilter />}
                  variant="unstyled"
                  onClick={() => this.setState({ isDrawerOpen: true })}
                  sx={{
                    marginLeft: "0px !important",
                    marginRight: "0.5rem !important",
                  }}
                />

                <Drawer
                  isOpen={isDrawerOpen}
                  placement="bottom"
                  onClose={() => this.setState({ isDrawerOpen: false })}
                >
                  <Flex alignItems="center">
                    <Heading as="h5" size="md" mb="0" mr="2">
                      {t("filters.heading")}
                    </Heading>
                    <IconButton
                      size="lg"
                      variant="ghost"
                      color="gray.200"
                      leftIcon={<Icon as={FaUndo} />}
                      onClick={this.handleFilterReset}
                    >
                      {t("filters.reset_filters")}
                    </IconButton>
                  </Flex>
                  <Divider mt="2" mb="4" ml="-6" mr="-6" width="auto" />

                  <Heading as="h6" size="sm" mb="4" mr="2">
                    {t("filters.status.heading")}
                  </Heading>
                  <Checkbox
                    mb="4"
                    ml="3"
                    onChange={this.handleFiltersChange}
                    isChecked={filterOptions[FilterStatuses.ALL]}
                    value={FilterStatuses.ALL}
                  >
                    {t("filters.status.all")}
                  </Checkbox>
                  <Stack pl="6" spacing="4" mb="4">
                    <Checkbox
                      onChange={this.handleFiltersChange}
                      isChecked={filterOptions[FilterStatuses.DRAFT]}
                      value={FilterStatuses.DRAFT}
                      mb="0"
                    >
                      {t("filters.status.draft")}
                    </Checkbox>
                    <Checkbox
                      isChecked={filterOptions[FilterStatuses.PUBLISHED]}
                      onChange={this.handleFiltersChange}
                      value={FilterStatuses.PUBLISHED}
                    >
                      {t("filters.status.published")}
                    </Checkbox>
                  </Stack>
                </Drawer>
              </HStack>
            ) : null}

            <StyledMarketPlaceGallery>
              <RecentFoldersRow
                parentLocation={
                  this.props.panelType === SAVED_ELEMENTS_PANEL
                    ? MY_COMPONENTS
                    : TEAM_TEMPLATES
                }
              />

              {loaded && payload.length > 0 ? (
                <TLDRInfiniteScroll
                  childrens={childElements}
                  className={"my-templates-components-infinite-scroll"}
                  loadMoreData={this.loadPage}
                  hasMore={hasMore}
                  scrollableTarget={MAIN_CONTAINER_SCROLLABLE_TARGET_ID}
                />
              ) : loaded && payload.length === 0 ? (
                this.state.searchTerm.length === 0 ? (
                  <EmptyStateScreen
                    description={
                      this.props.panelType === SAVED_ELEMENTS_PANEL ? (
                        t("intro_page.empty_screen_desc")
                      ) : (
                        <>
                          {t("intro_page.saved_templates_msg")}
                          <br />
                          {t("intro_page.inpiration")}
                        </>
                      )
                    }
                    link={
                      this.props.panelType === SAVED_ELEMENTS_PANEL
                        ? LAYOUTS
                        : TEMPLATES_SCREEN
                    }
                    linkPlaceholder={
                      this.props.panelType === SAVED_ELEMENTS_PANEL
                        ? t("intro_page.quick_start")
                        : t("intro_page.browse")
                    }
                  />
                ) : (
                  <ShowNoContent text={t("errors.no_data")} />
                )
              ) : (
                <ShowCenterSpinner loaded={loaded} />
              )}
            </StyledMarketPlaceGallery>
          </StyledMarketplaceContent>
        </HomeComponent>
      </>
    );
  }
}

MyTemplatesScreen.propTypes = {
  fetchData: PropTypes.func.isRequired,
  sidebarSlider: PropTypes.object.isRequired,
};

MyTemplatesScreen.defaultProps = {
  creatorId: null,
  excludeCreatorId: null,
};

const mapStateToProps = (state) => ({
  sidebarSlider: state.sidebarSlider,
  page: state.sidebarSlider.page,
  selectedOrg: state.auth.payload.selectedOrg,
  selectedCards: state.folders.selectedCards,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  resetAssets: () =>
    dispatch({
      type: BACK_FROM_STUDIO,
    }),
  search: (source, searchTerm, props) =>
    dispatch(search(source, searchTerm, props)),
  resetCardsSelection: () => dispatch(resetCardsSelection()),
  moveToFolder: (payload, folderId, folderName, token) =>
    dispatch(moveToFolder(payload, folderId, folderName, token)),
  deleteItemsInBulk: (props, token) =>
    dispatch(deleteItemsInBulk(props, token)),
  resetPage: (payload) => dispatch(resetPage(payload)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(MyTemplatesScreen)
);
